import _asyncToGenerator from "D:/Projects/NET2/UJP/Ostalo/PorocevalskiPortal/PorocevalskiPortalApp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useApi } from '@/lib/api';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  setup: function setup() {
    var _api = useApi();

    var data = ref([]);

    var getData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _api.get('news');

              case 2:
                res = _context.sent;
                data.value = res.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getData() {
        return _ref.apply(this, arguments);
      };
    }();

    getData();
    return {
      data: data
    };
  }
});